<template>
  <div class="realname-upload-wrap">
    <div class="hd">
      <p class="title">
        实名认证成功后，可以享受提现服务
      </p>
    </div>
    <div class="upload-form">
      <div class="row">
        <div class="preview">
          <img
            :src="form.hand_idcard_rid ? preview.hand_idcard_rid : placeholder1"
            alt=""
          >
        </div>
        <div class="info">
          <strong>上传手持证件照</strong><span class="tip">（2M以内）</span>
          <div class="btn-upload">
            <span>点击上传</span>
            <input
              ref="hand_idcard_rid_pic1"
              type="file"
              name="poster"
              accept="image/jpg, image/jpeg"
              data-type="hand_idcard_rid"
              @change="handlePosterUpload"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="preview">
          <img
            :src="preview.front_idcard_rid ? preview.front_idcard_rid : placeholder2"
            alt=""
          >
        </div>
        <div class="info">
          <strong>上传证件正面照</strong><span class="tip">（2M以内）</span>
          <div class="btn-upload">
            <span>点击上传</span>
            <input
              ref="front_idcard_rid_pic1"
              type="file"
              name="poster"
              accept="image/jpg, image/jpeg"
              data-type="front_idcard_rid"
              @change="handlePosterUpload"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="preview">
          <img
            :src="preview.reverse_idcard_rid ? preview.reverse_idcard_rid : placeholder3"
            alt=""
          >
        </div>
        <div class="info">
          <strong>上传证件反面照</strong><span class="tip">（2M以内）</span>
          <div class="btn-upload">
            <span>点击上传</span>
            <input
              ref="reverse_idcard_rid_pic1"
              type="file"
              name="poster"
              accept="image/jpg, image/jpeg"
              data-type="reverse_idcard_rid"
              @change="handlePosterUpload"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="rule-wrap">
      <dl>
        <dt>注意事项：</dt>
        <dd>1.每个证件只能绑定一个账号；</dd>
        <dd>2.证件照不清晰或与输入的信息不匹配，将导致认证被驳回；</dd>
        <dd>3您提供的证件信息将受到严格保护，仅用于身份验证，未经本人许可不会用于其他用途；</dd>
        <dd>4.除原证件无效（如：改名、移民）等特殊情况外，实名认证审核通过后将不能修改；</dd>
        <dd class="withdraw-tip">5.当前仅支持提现至相同实名信息的微信账户，实名不符将导致资金无法提现。</dd>
      </dl>
      <dl>
        <dt>证件要求：</dt>
        <dd>1.需上传本人露脸手持二代身份证背面照+身份证正反面照片（不需手持）；</dd>
        <dd>2.证件必须在有效期内，有效期需在一个月以上。</dd>
      </dl>
      <dl>
        <dt>照片要求：</dt>
        <dd>1.本人手持证件正面露脸，五官清晰可辩；</dd>
        <dd>2.证件照上信息需完整且清晰可辨（无反光、遮挡、水印、证件套、logo等）；</dd>
        <dd>3.证件照片信息需与签约时填写的信息一致，如需修改签约信息，请联系客服QQ：823431530；</dd>
        <dd>4.证件必须真实拍摄，不能使用复印件；</dd>
        <dd>5.确保照片完整（不缺边角），证件周围不允许加上角框（如：加上红框等）。</dd>
      </dl>
    </div>
    <div class="bt">
      <div class="ctrl">
        <span
          class="btn-publish"
          @click="handlePublish"
        >提交认证</span>
      </div>
    </div>
    <div
      v-if="confirmDialogText"
      class="confirm-dalog-wrap"
    >
      <ConfirmDialog
        :text="confirmDialogText"
        :confirm-text="confirmDialogConfirmText"
        @close="handleConfirmDialogClose"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventEmit from '@/utils/EventEmit'

import ConfirmDialog from '@/components/dialog/ConfirmDialog'

import { encryptUpload } from '@/api/upload'
import { doRealnameCommit } from '@/api/contractUpload'

export default {
  name: 'RealnameUpload',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      placeholder1: '//haohuo.cmcmcdn.com/other/36b720a4e9ae079d926a92d243c14216.png',
      placeholder2: '//haohuo.cmcmcdn.com/other/95ca4c0d8d881554d72d8a3d3bb8f8ce.png',
      placeholder3: '//haohuo.cmcmcdn.com/other/0d8c421ac245ce79655c6831343e5324.png',
      form: {},
      preview: {},
      picMaxSize: 2 * 1024 * 1024, // 2M
      previewWidth: 500,
      previewHeight: 500,
      confirmDialogText: '',
      confirmDialogConfirmText: '我知道了',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
  },
  mounted() {
    this.bind()
  },
  methods: {
    bind() {
      //
    },
    verification() {
      if (!this.userInfo.token) {
        EventEmit.$emit('SHOW_LOGIN_DIALOG')
        return false
      }

      if (!this.form.hand_idcard_rid) {
        this.confirmDialogText = '请上传手持身份证照'
        return false
      }

      if (!this.form.front_idcard_rid) {
        this.confirmDialogText = '请上传身份证正面照'
        return false
      }

      if (!this.form.reverse_idcard_rid) {
        this.confirmDialogText = '请上传身份证正面照'
        return false
      }

      return true
    },
    async handlePublish() {
      if (!this.verification()) {
        return
      }

      if (this.commiting) {
        return
      }

      this.commiting = true

      try {
        const data = Object.assign({
          common: this.common,
        }, this.form)
        const res = await doRealnameCommit(data)
        if (res.resp_common && !res.resp_common.ret) {
          this.confirmDialogText = '提交成功，实名认证进入审核流程，<br/>审核结果将通过元气壁纸消息中心通知您哦'
          this.form.commit = true
        }
      } catch (err) {
        if (err.resp_common) {
          this.confirmDialogText = err.resp_common.msg
        } else {
          this.confirmDialogText = err.message
        }
      }

      this.commiting = false
    },
    handleConfirmDialogClose() {
      this.confirmDialogText = ''
      if (this.form.commit) {
        this.$router.push('/creation')
      }
    },
    checkPicWidthHeight(file) {
      const $img = document.createElement('img')
      try {
        return new Promise((resolve/* , reject */) => {
          $img.onload = () => {
            const { width, height } = $img
            if (width >= this.previewWidth && height >= this.previewHeight) {
              resolve(true)
              return
            }

            resolve(false)
          }

          $img.onerror = () => {
            resolve(true)
          }

          try {
            $img.src = URL.createObjectURL(file)
          } catch (err) {
            resolve(true)
          }
        })
      } catch (err) {
        return true
      }
    },
    handlePosterUpload($event) {
      const $target = $event.target
      const picType = $target.dataset.type
      const file = $target.files && $target.files[0]
      if (!file) {
        this.handleRemovePreview($event)
        return
      }

      if (!file.name || !file.name.match(/\.jpg$/ig)) {
        this.confirmDialogText = '请上传jpg格式的预览图'
        this.handleRemovePreview($event)
        return
      }

      // 检查图片大小
      // if (await this.checkPicWidthHeight(file) === false) {
      //   this.confirmDialogText = `请上传尺寸不小于${this.previewWidth}*${this.previewHeight}的预览图`
      //   this.handleRemovePreview(picType)
      //   return
      // }

      if (file.size > this.picMaxSize) {
        this.confirmDialogText = '请上传2M以内的预览图'
        this.handleRemovePreview($event)
        return
      }

      this.encryptUpload(file, picType)
    },
    handleRemovePreview($event) {
      const $target = $event.currentTarget
      const type = $target.dataset.type
      this.form[type] = ''
      this.preview[type] = ''
      const key1 = `${type}_pic1`
      const key2 = `${type}_pic2`
      if (this.$refs[key1]) {
        this.$refs[key1].value = ''
      }
      if (this.$refs[key2]) {
        this.$refs[key2].value = ''
      }
      this.$forceUpdate()
    },
    /*
     * @param type {String} static:静态壁纸，live:动态壁纸文件，preview_jpg:预览图
     */
    async encryptUpload(file, type) {
      if (!type) {
        return
      }
      const data = new FormData()
      data.append('open_id', this.common.open_id)
      data.append('token', this.common.token)
      data.append('file', file)
      data.append('file_type', 'authrealname')

      try {
        const res = await encryptUpload(data)
        if (res.data) {
          this.form[type] = res.data.resource_id
          this.preview[type] = res.data.resource_url
          this.$forceUpdate()
        }
      } catch (err) {
        if (err.resp_common) {
          if (err.resp_common.ret === 4001002) {
            return
          }

          this.confirmDialogText = err.resp_common.msg
          return
        }

        this.confirmDialogText = err.message
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.realname-upload-wrap {
  width: 700px;
  min-height: 640px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
}
.hd {
  padding: 18px 25px;
  .title {
    font-size: 14px;
    font-weight: 700;
    color: #333;
  }
}
.upload-form {
  display: flex;
  padding: 0 25px;
  .row + .row {
    margin-left: 16px;
  }
}

.preview {
  width: 200px;
  height: 120px;
  padding: 2px;
  line-height: 120px;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  img {
    width: 100%;
  }
}

.info {
  position: relative;
  font-size: 12px;
  .tip {
    display: block;
    color: #A4A6AB;
  }
  .btn-upload {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

.btn-upload {
  display: inline-block;
  vertical-align: middle;
  width: 90px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 12px;
  background: #f5b903;
  border-radius: 8px;
  color: #333;
  overflow: hidden;
  font-weight: 700;
  input {
    position: absolute;
    left: 0;
    top: -200px;
    width: 120px;
    height: 600px;
    cursor: pointer;
  }
}

.rule-wrap {
  padding: 46px 25px 0;
  color: #531D08;
  dl {
    margin-bottom: 32px;
  }
  dt {
    margin-bottom: 10px;
    font-size: 14px;
  }
  dd {
    padding-left: 50px;
    line-height: 24px;
    font-size: 12px;
  }
  .withdraw-tip {
    color: #F41D83;
  }
}

.bt {
  text-align: center;
}

.confirm-dalog-wrap {
  &::before {
    content: '';
    z-index: 9;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
.ctrl {
  padding-bottom: 30px;
  .btn-publish {
    display: inline-block;
    width: 185px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    background: #f5b903;
    border-radius: 8px;
    color: #333;
    cursor: pointer;
  }
}
</style>
